import Pqp from "../../../3x1010/Pqp";
import Helper from "../../utils/helper/Helper";
import Screen from "../Screen";
import Skills from "../skills/Skills";

export default class FightLogger {
	constructor(target) {
		this.mc = target;

	}

	addLine(type, from, to, damage) {
		if (type === FightLogger.DAMAGE) {
			this.addDamageLine(from, to, damage);
		}
		if (type === FightLogger.PARRY) {
			this.addParryLine(from, to, damage);
		}
		if (type === FightLogger.MISS) {
			this.addMissLine(from, to, damage);
		}
		if (type === FightLogger.DIE) {
			this.addDieLine(from, to, damage);
		}
		if (type === FightLogger.HERO_WON) {
			this.addWonLine(from, to, damage);
		}
		if (type === FightLogger.HERO_LOST) {
			this.addLostLine(from, to, damage);
		}
		if (type === FightLogger.HERO_HEAL) {
			this.addHealLine(from, to);
		}
		if (type === FightLogger.HERO_LEVEL_UP) {
			this.addLevelUpLine(from, to);
		}
	}

	addDamageLine(from, to, damage) {
		let msg = this.createMessage();
		if (Pqp.rnd(1) == 0) {
			msg.html(from + " deals " + this.colorDamage(damage) + " damage to " + to + ".");
		} else {
			msg.html(from + " hits " + to + " for " + this.colorDamage(damage) + " damage.");
		}
		this.append(msg)
	}

	addParryLine(from, to, damage) {
		let msg = this.createMessage();
		msg.html(to + " parries an attack from " + from + ".");
		this.append(msg)
	}

	addMissLine(from, to, damage) {
		let msg = this.createMessage();
		msg.html(from + " misses " + to + ".");
		this.append(msg)
	}

	addDieLine(from, to, damage) {
		let msg = this.createMessage();
		msg.html(from + " dies!");
		this.append(msg)
	}

	addWonLine(hero, parms) {
		let msg = this.createMessage();
		msg.html(hero + " won the fight!<br>")
		this.append(msg)
		msg = this.createMessage();
		if (parms.level !== parms.newLevel) {
			msg.html(hero + " gains " + this.colorDamage(parms.xp) + " experience points and reaches " + this.colorNewLevel("level " + parms.newLevel) + "!");
		} else {
			msg.html(hero + " gains " + this.colorDamage(parms.xp) + " experience points.");
		}
		this.append(msg)
	}

	addLostLine(hero, parms) {
		let msg = this.createMessage();
		msg.html(hero + " lost the fight!")
		this.append(msg)
	}

	addHealLine(hero, heal) {
		let msg = this.createMessage();
		msg.html(hero + " heals for " + this.colorHeal(heal) + " hit points!")
		this.append(msg)
	}
	addLevelUpLine(hero, gained) {
		let msg = this.createMessage();
		msg.html(hero + gained);
		this.append(msg)
	}

	createMessage() {
		let msg = jQuery("#template-message").clone();
		msg.attr("id", "logmsg" + FightLogger.ENUM++);
		return msg;

	}

	append(msg) {
		this.mc.append(msg)
		this.mc.scrollTop(10000);
	}

	colorDamage(s) {
		return "<span class='text-light-blue'>" + s + "</span>";
	}
	colorNewLevel(s) {
		return "<span class='text-orange'>" + s + "</span>";
	}
	colorHeal(s) {
		return "<span class='text-green'>" + s + "</span>";
	}


	showSkillGain(skill, value, inc, delay) {
		//return
		let msg = this.createMessage();
		msg.html(this.colorDamage("Your skill in " + Skills.getSkillName(skill) + " has increased by 0." + inc + "%. It is now " + Helper.toSkill(value)));
		setTimeout(this.append.bind(this, msg), delay);
		//this.append(msg)
		if (Screen.that.skills) {
			Screen.that.skills.update();
		}
	}
}

FightLogger.ENUM = 0;
FightLogger.DAMAGE = "damage";
FightLogger.PARRY = "parry";
FightLogger.MISS = "miss";
FightLogger.DIE = "die";
FightLogger.HERO_WON = "hero_won";
FightLogger.HERO_LOST = "hero_lost";
FightLogger.HERO_HEAL = "hero_heal";
FightLogger.HERO_LEVEL_UP = "hero_level_up";